(() => {
  'use strict';
  const selector = '[data-cleavie-product]';
  const localDate = (date) => [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-');

  function initialize(root) {
    if (root.dataset.cvgReady === 'true') return;
    const form = root.querySelector('[data-cvg-form], form');
    if (!form) return;
    root.dataset.cvgReady = 'true';
    const isPreview = root.hasAttribute('data-cvg-draft-preview');
    const modes = Array.from(form.querySelectorAll('[data-cvg-mode]'));
    const recipient = form.querySelector('[data-cvg-recipient]');
    const fields = Array.from(form.querySelectorAll('[data-cvg-recipient-field]'));
    const email = form.querySelector('[data-cvg-email]');
    const date = form.querySelector('[data-cvg-date]');
    const dateWrap = form.querySelector('[data-cvg-date-wrap]');
    const deliveryChoice = form.querySelector('[data-cvg-delivery-choice]');
    const offset = form.querySelector('[data-cvg-offset]');
    const message = form.querySelector('[data-cvg-message]');
    const announcement = form.querySelector('[data-cvg-announcement]');
    const delivery = form.querySelector('[data-cvg-delivery]');
    const gifting = () => modes.some((mode) => mode.checked && mode.value === 'gift');
    const currentAmount = () => form.querySelector('[data-cvg-amount]:checked');

    function refreshDateBounds() {
      const today = new Date();
      const lastDay = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 90);
      date.min = localDate(today);
      date.max = localDate(lastDay);
      offset.value = String(today.getTimezoneOffset());
    }

    function updateDelivery() {
      const later = gifting() && deliveryChoice.value === 'later';
      dateWrap.hidden = !later;
      date.disabled = !later;
      date.required = later;
      refreshDateBounds();
    }

    function updateMode(announce = true) {
      const isGift = gifting();
      recipient.hidden = !isGift;
      recipient.disabled = !isGift;
      fields.forEach((field) => { field.disabled = !isGift; });
      email.required = isGift;
      delivery.hidden = isGift;
      if (announce) announcement.textContent = isGift ? 'Les renseignements du destinataire sont maintenant disponibles.' : 'La carte sera envoyée à votre adresse courriel.';
      updateDelivery();
    }

    function updateAmount(announce = true) {
      const option = currentAmount();
      if (!option) return;
      for (const node of root.querySelectorAll('[data-cvg-card-value], [data-cvg-summary-value], [data-cvg-original]')) node.textContent = option.dataset.cvgValue;
      const total = form.querySelector('[data-cvg-total]');
      if (total) total.textContent = option.dataset.cvgPrice;
      const summary = form.querySelector('[data-cvg-offer-summary]');
      if (summary && !summary.hidden) summary.textContent = `${option.dataset.cvgSaving} de plus pour choisir ce qui vous fait du bien.`;
      if (announce) announcement.textContent = `Carte de ${option.dataset.cvgValue}. ${isPreview ? 'Prix proposé' : 'À payer'} : ${option.dataset.cvgPrice}.`;
    }

    modes.forEach((mode) => {
      mode.disabled = false;
      mode.addEventListener('change', () => updateMode());
    });
    if (recipient.hasAttribute('data-cvg-restore-gift') || root.dataset.cvgDefaultMode === 'gift') modes.forEach((mode) => { mode.checked = mode.value === 'gift'; });
    if (date.value) deliveryChoice.value = 'later';
    form.querySelectorAll('[data-cvg-amount]').forEach((option) => option.addEventListener('change', () => updateAmount()));
    const updateCount = () => { form.querySelector('[data-cvg-message-count]').textContent = String(message.value.length); };
    message.addEventListener('input', updateCount);
    date.addEventListener('focus', refreshDateBounds);
    deliveryChoice.addEventListener('change', updateDelivery);

    if (isPreview) {
      const purchaseView = root.querySelector('[data-cvg-purchase-view]');
      const experience = root.querySelector('[data-cvg-experience]');
      const giftView = root.querySelector('[data-cvg-gift-view]');
      const giftCard = giftView.querySelector('cleavie-gift-card');
      const previewButton = form.querySelector('[data-cvg-preview-open]');
      function presentGift({ fromEmail = false, instant = false } = {}) {
        if (!customElements.get('cleavie-gift-card')) {
          announcement.textContent = 'L’aperçu animé est encore en cours de chargement. Réessayez dans un instant.';
          return;
        }
        const name = fromEmail ? 'Camille' : gifting() ? form.querySelector('[data-cvg-name]').value.trim() : '';
        const face = fromEmail ? '100' : currentAmount().dataset.cvgValueAmount;
        giftCard.reset();
        for (const [key, value] of Object.entries({
          value: face,
          balance: face,
          recipient: name,
          sender: fromEmail ? 'Alex' : '',
          message: fromEmail ? 'Un petit moment rien que pour toi. Profite de tes petits bonheurs préférés. ♥' : gifting() ? message.value.trim() : '',
          code: 'DEMO-NON-VALABLE'
        })) giftCard.setAttribute(key, value);
        const title = giftView.querySelector('[data-cvg-gift-title]');
        title.textContent = instant ? 'Votre carte-cadeau, en un coup d’œil.' : name ? `${name}, une surprise vous attend.` : 'Un petit bonheur vous attend.';
        purchaseView.hidden = true;
        experience.hidden = true;
        giftView.hidden = false;
        if (instant) giftCard.open({instant:true});
        giftView.scrollIntoView({behavior:'instant', block:'start'});
        title.focus({preventScroll:true});
      }
      // The design preview is a div, not a form: it cannot submit or add a product,
      // even when JavaScript is unavailable. All personal text stays in this DOM.
      previewButton.addEventListener('click', () => {
        refreshDateBounds();
        const invalid = Array.from(form.querySelectorAll('input, textarea, select')).find((field) => !field.disabled && !field.checkValidity());
        if (invalid) { invalid.reportValidity(); return; }
        if (!currentAmount()) return;
        previewButton.disabled = true;
        try {
          presentGift();
        } finally { previewButton.disabled = false; }
      });
      root.querySelector('[data-cvg-preview-back]').addEventListener('click', () => {
        giftView.hidden = true;
        purchaseView.hidden = false;
        experience.hidden = false;
        giftCard.reset();
        previewButton.focus({preventScroll:true});
        root.querySelector('.cvg-product__panel').scrollIntoView({behavior:'instant', block:'start'});
      });
      root.querySelector('[data-cvg-preview-replay]').addEventListener('click', () => {
        giftCard.reset();
        giftCard.querySelector('button')?.focus({preventScroll:true});
      });
      // These two fixed demo routes never accept personal information or real codes.
      const followDemoLink = () => {
        if (root.isConnected && ['#cadeau', '#solde'].includes(window.location.hash)) {
          presentGift({fromEmail:true, instant:window.location.hash === '#solde'});
        }
      };
      window.addEventListener('hashchange', followDemoLink);
      // Also support clicking the same email link twice without changing the hash.
      root.closest('main')?.addEventListener('click', (event) => {
        const link = event.target.closest?.('a[href="#cadeau"], a[href="#solde"]');
        if (!root.isConnected || !link) return;
        event.preventDefault();
        presentGift({fromEmail:true, instant:link.getAttribute('href') === '#solde'});
      });
      if (customElements.get('cleavie-gift-card')) followDemoLink();
      else customElements.whenDefined('cleavie-gift-card').then(followDemoLink);
    } else {
      form.addEventListener('submit', (event) => {
        refreshDateBounds();
        // Native POST preserves Shopify gift-card recipient validation and errors.
        // Shopify, never this script, generates the code and computes payment.
        if (!form.checkValidity()) {
          event.preventDefault();
          form.reportValidity();
        }
      });
    }
    updateMode(false);
    updateAmount(false);
    updateCount();
    // Browser back/forward can restore radio values after initialisation.
    window.addEventListener('pageshow', () => {
      if (!root.isConnected) return;
      updateMode(false);
      updateAmount(false);
      updateCount();
    });
    form.querySelector('[data-cvg-server-errors]')?.focus({preventScroll:true});
  }

  function scan(scope) {
    if (scope.matches?.(selector)) initialize(scope);
    scope.querySelectorAll?.(selector).forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), {once:true});
  else scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
